import _get from 'lodash/get'

import {
    DIVIDENDS_AND_INTEREST_SAVE_ERROR,
    DIVIDENDS_AND_INTEREST_SAVE_SUCCESS,
    DIVIDENDS_AND_INTEREST_SAVING,
    DIVIDENDS_AND_INTEREST_UPDATE,
} from '../actions'

export default (
    state = {
        shouldFetch: true,
        activeQuestionIndex: 0,
        activeQuestionNumber: 1,
    },
    action
) => {
    switch (action.type) {
        case DIVIDENDS_AND_INTEREST_UPDATE:
            return { ...state, ...action.dividendsAndInterest }

        case DIVIDENDS_AND_INTEREST_SAVING:
            return { ...state, isSaving: true }

        case DIVIDENDS_AND_INTEREST_SAVE_SUCCESS:
            return {
                ...state,
                ...action.dividendsAndInterest,
                isSaving: false,
                goToNextQuestion: true,
                saveError: false,
                errorMessage: '',
                validationErrors: null,
            }

        case DIVIDENDS_AND_INTEREST_SAVE_ERROR:
            return {
                ...state,
                ...action.dividendsAndInterest,
                isSaving: false,
                goToNextQuestion: false,
                saveError: true,
                errorMessage: _get(action, ['errorResponse', 'message'], 'Unknown error occurred'),
                validationErrors: _get(action, ['errorResponse', 'modelState'], false),
            }
        default:
            return state
    }
}
